export default (v) =>
    `\u20AC ${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`